    <template>
    <div class="modules">
        <div class="fund-container">
            <div class="summary">
                <h1 class="title">   {{$t("lang.Profile")}}</h1>
            </div>
            <div class="mod">
                <div class="bd">
                    <div class="userinfo">
                        <div class="avatar-wrapper">
                            <img :src="avatar ? avatar:require('@/assets/avatar.jpg')" class="avatar" />
                        </div>
                        <div class="info">
                            <div class="email">{{ userInfo.email }}</div>
                            <div class="Referral"> {{ $t('lang.Referral') }}：{{ userInfo.inviteCode }} <i class="icon el-icon-copy-document" @click="copyOrderId(userInfo.inviteCode)"></i></div>
                            <van-uploader :after-read="afterRead"  :headers="headers" :action="modifyHeadImg">
                                <van-button type="default" size="small">
                                    {{$t("lang.EditProfilePhoto")}}
                                    <van-icon name="arrow" />
                                </van-button>
                            </van-uploader>
                        </div>
                    </div>
                    <div class="">
                        
                    </div>
                </div>
         </div>
         <van-cell-group>
            <van-cell :title="$t('lang.ViewInvitationCode')" is-link @click="$router.push({name:'invite'})" />
             <div class="Invitation"  element-loading-spinner="el-icon-loading" v-if="!userInfo.parentInviteCode">
                <el-form>
                    <el-form-item class="form-item" >
                        <el-input v-model="form.inviteCode" :placeholder="$t('lang.referral')" maxlength="6" >
                            <template slot="append">
                                <el-button class="bt" type="primary"   @click="playInviteCode()">{{ $t('lang.Referral') }}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
               </el-form>
            </div>
        </van-cell-group>
        </div>
    </div>
    </template>
    <script>
    import {BASE_GLOB_API} from "@/config.js";
    import {axiosGet,axiosPost} from '@/api/api';
    import EventBus from '@/utils/EventBus';
    import { Toast } from 'vant';

    export default {
        name:'payment',
        components:{},
        data(){
            return {
                Language: "en",
                api:BASE_GLOB_API,
                url:{
                    info:BASE_GLOB_API+'/user/info',
                    modifyHeadImg:BASE_GLOB_API+'/user/modifyHeadImg',
                    inviteCode:BASE_GLOB_API+'/user/bind/inviteCode',
                },
                modifyHeadImg:BASE_GLOB_API+'/user/modifyHeadImg',
                lang: "",
                userInfo:{},
                avatar:'',
                headers:{},
                form:{
                    inviteCode:''
                }
            }
        },
        created(){
            this.lang = sessionStorage.getItem("Language")
            this.platform()
            
        },
        methods:{
            playInviteCode(){
            if(!this.form.inviteCode){
                this.$message.error(this.$t("lang.referral"));
                return;
            }
          
            axiosPost(this.url.inviteCode,{inviteCode:this.form.inviteCode}).then(res=>{
                if(res.code == 200){
                    this.form.inviteCode =''
                    this.platform()
                }
              
            })
           },
            copyOrderId(content){
                this.$copyText(content).then(res=>{
                    Toast.success(this.$t("lang.replicationSuccessful"))
                },
                err => {
                    Toast.fail(this.$t("lang.replicationFailed"))
                })
            },
            afterRead(file) {
                console.log("file",file);
            
                let data = new FormData();
                data.append("headImgFile", file.file);
                axiosPost(this.modifyHeadImg, data).then(res=>{
                    if(res.code == 200){
                        EventBus.$emit('modifyHeadImg', 1);
                        this.platform()
                    }
                    
                })
            },
            platform(){
                axiosGet(this.url.info).then(res=>{
                    if(res.code ==200){
                        this.userInfo =res.result
                        if(this.userInfo.headImg){
                            this.avatar =this.api + this.userInfo.headImg
                        }else{
                            this.avatar =''
                        }
                        let userinfo = {
                            id:this.userInfo.id,
                            account:this.userInfo.account,
                            nikeName:this.userInfo.nikeName,
                            avatar:this.userInfo.headImg,
                            email:this.userInfo.email,
                        }
                        window.sessionStorage.setItem("userinfo", JSON.stringify(userinfo));
                        EventBus.$emit('img',  this.userInfo);
                    }else{
                        this.$message.error(res.message);
                    }
                })
           
        }, 
        }
    }
    </script>
    <style lang="less" scoped>
    .fund-container {
        .summary {
            background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
        }
        .mod {
            margin-bottom:16px;
           .bd {
                background:#fff; padding:16px;
                .userinfo {
                    display:flex; justify-content: flex-start; align-items: center; margin-bottom:10px;
                    .avatar-wrapper {
                        width:88px; height:88px; min-width:49px; margin-right:10px;
                        .avatar {
                            width:100%; height:100%; border-radius:50%;
                        }
                    }
                    .info {
                        .email {
                            font-size:18px; font-weight:700; margin-bottom:10px;
                        }
                        .Referral{
                            padding: 2px 0 15px 5px
                        }
                    }
                }
           } 
        }
        .Invitation{
            padding: 3px 15px;margin-top:20px ;
           .bt{
            color: #fff;
           }
        }
        .card {
            .hd {
                display:flex; justify-content: space-between; align-items: center; padding:0 0 20px; border-bottom:#e6e6e6 1px solid; margin-bottom:20px;
                .title {
                    .text {
                        font-size:18px; font-weight:700; padding:0 0 10px;
                    }
                    .val {
                        display:flex; justify-content: flex-start; align-items: center;
                        ::v-deep .select {
                            .el-input {
                                position:relative; width:auto;
                                .el-input__inner {border:0 none; font-size:24px; font-weight:700; font-family: 'bebas_neueregular'; padding-left:0; display:block; width:100%; min-width:0;}
                                .el-input__suffix {
                                    background:#f4f5f6; border-radius:4px;
                                }
                                &:after {
                                    content:""; display:block; border-bottom:#ccc 1px dashed; margin-right:32px;
                                }
                            }
                        }
                        .exchange {
                            display:flex; justify-content: flex-start; align-items: center; margin-right:6px;
                            .exchange-show {
                                display:flex; justify-content: flex-start; align-items: center;
                                .num {font-family: 'bebas_neueregular'; font-size:24px; display:block;}
                                .unit {font-size:20px; font-weight:700; display:block; margin:0 8px 0 4px;}
                            }
                            .el-dropdown-link {
                                width:26px; height:26px; display:block; border-radius:4px; background:#f4f5f6; display:flex; justify-content: center; align-items: center; margin-left:4px; cursor: pointer;
                            }
                        }
                        .symbol, .dollar {
                            font-size:20px; color:#666; margin:0 4px; font-weight:700;
                        }
                    }
                }
                .tools {
                    display:flex; justify-content: space-between; align-items: center;
                    .item {
                        padding:0 10px;
                    }
                }
            }
            .bd {
                .table-wrapper {
                    .table-tools {
                        display:flex; justify-content: flex-start; align-items: center;
                        .search-wrapper {
                            margin-right:10px;
                        }
                        ::v-deep .el-checkbox {
                            .el-checkbox__label {font-weight:normal;}
                        }
                    }
                    .table-inner {
                        padding:10px 0;
                        .icon{
                            width:6%; height:6%;
                        }
                    }
                }
            }
        }
    }
    .select-option-coin-item {
        display:flex; justify-content: flex-start; align-items: center;
    }
    .select-option-network-item {}
    </style>